import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';
import IconCustomize from 'components/icons/iconCustomize2';
import { colorBrand } from 'styles/layout/colors';
const PDPFreeSwatchKitButton = t0 => {
  const $ = _c(4);
  const {
    onClick: t1,
    styling: t2
  } = t0;
  const onClick = t1 === undefined ? _temp : t1;
  const styling = t2 === undefined ? "link" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-sm font-bold items-center text-brand flex hover:!underline whitespace-nowrap"><IconCustomize color={colorBrand} height={16} width={22} className="!mr-2" /><span>Get free swatches</span></span>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== onClick || $[2] !== styling) {
    t4 = <CtaButton styling={styling} color="brand" hasArrow={false} data-xc="PDPGetFreeSwatchesButton" onClick={onClick} className="PDPFreeSwatchKitButton">{t3}</CtaButton>;
    $[1] = onClick;
    $[2] = styling;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
PDPFreeSwatchKitButton.propTypes = {
  onClick: PropTypes.func,
  styling: PropTypes.string
};
export default PDPFreeSwatchKitButton;
function _temp() {}